export default "__VITE_ASSET__pXbczNKc__"